import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { useLocation, useNavigate } from "react-router-dom";
import VehicleDashboard from "./VehicleDashboard";
import VehicleAttendance from "./VehicleAttendance";
import AttendanceByDay from "./AttendanceByDay";
import VehicleStopsPreview from "./VehicleStopsPreview";

export default function VehicleTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  const pathname = location.pathname.toLowerCase();
  const tabFromPath = pathname.endsWith("/stopspreview")
    ? "stops"
    : pathname.endsWith("/attendance")
      ? "attendance"
      : pathname.endsWith("/attendance-by-day")
        ? "byday"
        : "dashboard";

  const handleTabChange = (value) => {
    if (value === "stops") {
      navigate("/dashboard/stopspreview");
      return;
    }
    if (value === "attendance") {
      navigate("/dashboard/attendance");
      return;
    }
    if (value === "byday") {
      navigate("/dashboard/attendance-by-day");
      return;
    }
    navigate("/dashboard");
  };

  return (
    <div className="max-w-3xl mx-auto mt-10 p-4">
      <Tabs value={tabFromPath} onValueChange={handleTabChange}>
        <TabsList className="mb-4">
          <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
          <TabsTrigger value="attendance">Attendance</TabsTrigger>
          <TabsTrigger value="byday">Attendance by Day</TabsTrigger>
          <TabsTrigger value="stops">Stops Preview</TabsTrigger>
        </TabsList>
        <TabsContent value="dashboard">
          <VehicleDashboard />
        </TabsContent>
        <TabsContent value="attendance">
          <VehicleAttendance />
        </TabsContent>
        <TabsContent value="byday">
          <AttendanceByDay />
        </TabsContent>
        <TabsContent value="stops">
          <VehicleStopsPreview />
        </TabsContent>
      </Tabs>
    </div>
  );
} 